import React, { useEffect } from 'react';
import { Container, Row } from '@paypalcorp/pp-react';
import styles from './stepperStyles.less';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { StepperImage } from './stepperImage';
import { StepperComponent } from './stepperComponent';
import { StepperHeader } from './stepperHeader';
import * as analytics from '../../lib/analytics';

const StepperModule = (props) => {
  const {
    header,
    subHeader,
    image,
    stepsContent,
    backgroundColor,
    backgroundImageColor,
    setImageToTheLeft,
    buttonText,
    linkUrl,
    isPrimaryModule,
    instrumentation,
    authState,
    contentCountry,
    elmo,
  } = props;

  useEffect(() => {
    const commonTags = {
      xe: elmo.idExperiments,
      xt: elmo.idTreatments,
      item_name: 'dw_giving',
      scope: 'module',
      card_type: 'steps_module',
      tile_id: 'steps_module',
      module: 'steps_module',
      acct_cntry: contentCountry,
      tile_id_type: 'steps_module',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
    };
    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_LOADED, {
      e: 'av',
      state: 'loaded',
      ...commonTags,
    });

    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_SHOWN, {
      e: 'im',
      state: 'populated',
      ...commonTags,
    });
  }, []);

  const imageComponent = (isMobile) => (
    <StepperImage
      isMobileView={isMobile}
      backgroundImageColor={backgroundImageColor}
      image={image}
      key='StepperImage'
    />
  );

  const stepperComponent = () => {
    return (
      stepsContent &&
      stepsContent.length > 0 && (
        <StepperComponent
          stepsContent={stepsContent}
          isPrimaryModule={isPrimaryModule}
          linkUrl={linkUrl}
          buttonText={buttonText}
          key='stepperComponent'
          instrumentation={instrumentation}
          authState={authState}
          elmo={elmo}
        />
      )
    );
  };

  const headerComponent = (isMobileView) => {
    return (
      <StepperHeader
        header={header}
        subHeader={subHeader}
        isMobileView={isMobileView}
        isPrimaryModule={isPrimaryModule}
        key='headerComponent'
      >
        {stepperComponent()}
      </StepperHeader>
    );
  };
  return (
    <Container form={true}>
      <Container
        className={`${styles.stepperModuleContainer}`}
        style={{ backgroundColor: `${backgroundColor}` }}
      >
        <MediaQuery maxWidth={480}>
          <Row noGutters={true}>
            {[imageComponent(true), headerComponent(true)]}
          </Row>
        </MediaQuery>

        <MediaQuery minWidth={481}>
          <Row noGutters={true}>
            {setImageToTheLeft
              ? [imageComponent(), headerComponent()]
              : [headerComponent(), imageComponent()]}
          </Row>
        </MediaQuery>
      </Container>
    </Container>
  );
};
StepperModule.propTypes = {
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  stepsContent: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
  backgroundColor: PropTypes.string.isRequired,
  backgroundImageColor: PropTypes.string.isRequired,
  setImageToTheLeft: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  isPrimaryModule: PropTypes.bool.isRequired,
  instrumentation: PropTypes.shape({
    card_type: PropTypes.string,
    domain: PropTypes.string,
    item_name: PropTypes.string,
    module: PropTypes.string,
    scope: PropTypes.string,
    tile_id: PropTypes.string,
  }),
  authState: PropTypes.string,
  contentCountry: PropTypes.string,
  elmo: PropTypes.object,
};

StepperModule.defaultProps = {
  setImageToTheLeft: true,
};

export { StepperModule };
